<template>
  <div class="tab-box">
    <div class="selection-area">
      <div v-for="item in activeTab" :key="item.active" @click="changeTab(item.active)">
        <el-dropdown
          v-if="item.children.length > 0"
          :trigger="isPc ? 'hover' : 'click'"
          @command="clickDropdownMenu"
          placement="bottom-start"
        >
          <div
            :class="getTabClass(item.active)"
            :style="getTabStyle(item)"
          >
            <template v-if="isPc">
              <span>{{ item.title }}</span>
              <span>{{ item.titleS }}</span>
              <span class="add-tips">{{ item.tip===' '?'\u00A0':item.tip }}</span>
            </template>
            <template v-else>
              <span v-for="value in item.titleOptions" :key="value">{{ value }}</span>
            </template>
          </div>
          <el-dropdown-menu slot="dropdown" :class="theme.tabsBg">
            <el-dropdown-item v-for="it in item.children" :command="it" :key="it.id">{{ it.title }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div
          v-else
          :class="getTabClass(item.active)"
          :style="getTabStyle(item)"
        >
          <template v-if="isPc">
              <span>{{ item.title }}</span>
              <span>{{ item.titleS }}</span>
              <span class="add-tips">{{ item.tip===' '?'\u00A0':item.tip }}</span>
          </template>
          <template v-else>
            <span v-for="value in item.titleOptions" :key="value">{{ value }}</span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { activeTab } from '../utils/index.js';

export default {
  name: 'TabBox',
  props: {
    theme: {
      type: Object,
      required: true
    },
    isPc: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeTab: activeTab
    };
  },
  methods: {
    getTabClass(active) {
      if (active === 12) return 'sel-tab long-5-sel-tab';
      if ([1, 2].includes(active)) return 'sel-tab long-4-sel-tab';
      if (active === 6) return 'sel-tab long-3-sel-tab';
      if (active === 13) return 'sel-tab long-sel-tab';
      if (active === 11) return 'sel-tab';
      return 'sel-tab';
    },
    getTabStyle(item) {
      const bgImage = item.show ? this.theme.tabbt : 'greytabbt.png';
      return { background: `url(${require('./../assets/' + bgImage)}) no-repeat 0 0/100% 100%` };
    },
    changeTab(active) {
      this.$emit('change-tab', active);
    },
    clickDropdownMenu(command) {
      this.$emit('dropdown-click', command);
    }
  }
};
</script>

<style scoped>
.tab-box {
  background: #fff;
  margin-top: -2px;
  padding-top: 4px;
}

.selection-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto 2%;
}

.selection-area .sel-tab {
  flex: 1;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin: 0 4px;
  padding: 2px 4px;
  height: 50px;
  color: #fff;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
  min-width: 52px;
}

.sel-tab span {
  display: inline-block;
}

.selection-area .add-tips {
  font-size: 12px;
}

/* 媒体查询 */
@media screen and (max-width: 1500px) {
  .selection-area .sel-tab {
    font-size: 16px;
  }
}

@media screen and (max-width: 1200px) {
  .selection-area .sel-tab {
    font-size: 14px;
    margin: 0 2px;
    padding: 2px 2px;
    height: 38px;
    min-width: 28px;
  }
}

@media screen and (max-width: 1024px) {
  .selection-area .sel-tab {
    margin: 0 1px;
    padding: 1px 1px;
    font-size: 12px;
    height: 36px;
    min-width: 26px;
  }
}

@media screen and (max-width: 768px) {
  .selection-area .sel-tab {
    margin: 0 2px;
    padding: 1px 2px;
    height: auto;
    min-height: 58px;
    justify-content: center;
    min-width: 38px;
  }
  .selection-area {
    margin: auto 1%;
  }
}

@media screen and (max-width: 500px) {
  .selection-area .sel-tab {
    margin: 0 1px;
    padding: 1px 2px;
    min-width: 32px;
  }
}
@media screen and (max-width: 360px) {
  .selection-area .sel-tab {
    min-width: 28px;
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TabBox.vue